import type { Feature } from './feature'

export class Selectors {
  /**
   * Basic information about the currently logged in user
   *
   * @see {@link currentUserId}
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly currentUser

  /**
   * Identifies the currently logged in user
   *
   * @see {@link currentUser}
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly currentUserId

  /**
   * Whether or not we are currently retrieving data about the currently logged
   * in user
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /**
   * The error that occurred while trying to retrieve data about the currently
   * logged in user
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(feature: Feature) {
    const userInfo = feature.state.project(state => state.user)

    this.currentUser = userInfo.project(info => info?.data)
    this.currentUserId = this.currentUser.project(user => user?.id)

    this.error = userInfo.project(info => info?.error)
    this.isLoading = userInfo.project(info => info?.isLoading)
  }
}
